// extracted by mini-css-extract-plugin
module.exports = {"background":"LandingPage_background__2qOMd","doggy":"LandingPage_doggy__3dTiK","patita":"LandingPage_patita__1egj0"};